// eslint-disable-next-line import/prefer-default-export
export function pathChanged(payload) {
    return { payload, type: 'PATH_CHANGED' };
}
